import { SvgProps } from "../../types";

const SimCard = (props: SvgProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={18}
    height={14}
    fill="none"
    {...props}>
    <path
      fill="#1280E7"
      d="M3.854 10.448h6.97V8.705h-6.97v1.743Zm8.712 0h1.742V8.705h-1.742v1.743ZM3.854 6.963h1.742V5.221H3.854v1.742Zm3.484 0h6.97V5.221h-6.97v1.742Zm-5.227 6.97c-.479 0-.889-.171-1.23-.512a1.678 1.678 0 0 1-.512-1.231V1.736c0-.48.17-.89.512-1.23a1.678 1.678 0 0 1 1.23-.512h13.94c.478 0 .889.17 1.23.511.34.342.512.752.512 1.231V12.19c0 .48-.171.89-.512 1.23a1.678 1.678 0 0 1-1.23.512H2.11Zm0-1.743h13.94V1.736H2.11V12.19Z"
    />
  </svg>
);
export default SimCard;
